import type { GlobalState } from '../index';

export const selectProductsList = (state: GlobalState) => state.products.productsList;
export const selectProductDetails = (id: string) => (state: GlobalState) => state.products.specificProducts?.[id];
